import { render, staticRenderFns } from "./HomepageTopx.vue?vue&type=template&id=722d7bce"
import script from "./HomepageTopx.vue?vue&type=script&lang=js"
export * from "./HomepageTopx.vue?vue&type=script&lang=js"
import style0 from "./HomepageTopx.vue?vue&type=style&index=0&id=722d7bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports